module.exports = __webpack_public_path__ + "static/media/tick-white.f19ec76f.svg";